import { Offerte } from "../model/offerte";
import { Soglie } from "../model/soglie";

export class IrenWeb {
  public static  offerta ():Offerte {
      return {
		Flg_Indicizzato: false,
        Id_Offerta: 106,
        Id_Foritore: 1,
        Id_comodity: 1,
        TipoContratto:1,
        NomeOfferta: "ENERGIA WEB",
        LinkFoto: "./assets/images/offerte-iren/web-ele.jpg",
        LinkFotoLarge: "./assets/images/offerte-iren/web-ele.jpg",
        LinkFotoMid: "./assets/images/offerte-iren/web-ele.jpg",
        LinkFotoSm: "./assets/images/offerte-iren/web-ele.jpg",
        LinkFotoCarousel: "./assets/images/offerte-iren/web-ele.jpg",
        DescrizioneCarousel: "Che Offerta super",
        PromozioneOfferta: "",
        DescrizioneNomeOfferta: "Iren luce gas e servizi, propone un’offerta luce e/o gas studiata in base ai bisogni delle famiglie e delle piccole aziende che sempre più spesso chiedono prezzi allineati alle proprie abitudini di consumo (da qui la nascita delle tariffe MONORARIE, BIORARIE, ecc.).",
        Sezioni: [
          {
            NomeSezione: "RISPARMIO ASSICURATO",
            DescrizioneSezione: "Per risparmiare sulle bollette di luce e gas, la soluzione migliore è quella di acquisire comportamenti che limitino il consumo. Sappiamo che gli sprechi di energia elettrica e gas in casa sono comuni ed è faticoso far cambiare abitudini a tutta la famiglia. Per questo motivo scegliere una offerta di luce e gas conveniente è la soluzione che può portare a concreti risparmi in bolletta.",
            lstPunti: []
          },
          {
            NomeSezione: "",
            DescrizioneSezione: "Scegliere Iren luce gas e servizi conviene!",
            lstPunti: [
            ]

          },
          {
            NomeSezione: "",
            DescrizioneSezione: "IREN Web: la comodità del web e un prezzo bloccato per un anno.",
            lstPunti: [
            ]

          }
        ],
        PrezzoEle: 0.0689,
        PrezzoGas: 0,
       
        TitoloPlus: "RISPARMIO ASSICURATO",
        Plus: ["Prezzo bloccato per 1 anno", "Nessuna spesa di passaggio al mercato libero",
        "Nessun costo aggiuntivo"]
        , schedaconfrontabilitaele: {
          tabellaConfrontabilita: [
            { consumoannuo: 1500, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 294.21 },
            { consumoannuo: 2200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 392.04 },
            { consumoannuo: 2700, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 470.27 },
            { consumoannuo: 3200, tipoprofilo: 1, Residente: 1, potenza: 3, importo: 548.51 },
            { consumoannuo: 1500, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 294.21 },
            { consumoannuo: 2200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 392.04 },
            { consumoannuo: 2700, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 470.27 },
            { consumoannuo: 3200, tipoprofilo: 2, Residente: 1, potenza: 3, importo: 548.51 },
            { consumoannuo: 1500, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 294.21 },
            { consumoannuo: 2200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 392.04 },
            { consumoannuo: 2700, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 470.27 },
            { consumoannuo: 3200, tipoprofilo: 3, Residente: 1, potenza: 3, importo: 548.51 },
  
            
            { consumoannuo: 900, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 356.74 },
            { consumoannuo: 4000, tipoprofilo: 1, Residente: 2, potenza: 3, importo: 789.89 },
            { consumoannuo: 900, tipoprofilo:2, Residente: 2, potenza: 3, importo: 356.74},
            { consumoannuo: 4000, tipoprofilo: 2, Residente: 2, potenza: 3, importo: 789.89 },
            { consumoannuo: 900, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 356.74},
            { consumoannuo: 4000, tipoprofilo: 3, Residente: 2, potenza: 3, importo: 789.89 },
  
            { consumoannuo: 3500, tipoprofilo: 1, Residente: 1, potenza: 4.5, importo: 1050.51 },
            { consumoannuo: 3500, tipoprofilo: 2, Residente: 1, potenza: 4.5, importo: 1050.51 },
            { consumoannuo: 3500, tipoprofilo: 3, Residente: 1, potenza: 4.5, importo: 1050.51},
  
            { consumoannuo: 3500, tipoprofilo: 1, Residente: 2, potenza: 4.5, importo: 1050.51 },
            { consumoannuo: 3500, tipoprofilo: 2, Residente: 2, potenza: 4.5, importo: 1050.51 },
            { consumoannuo: 3500, tipoprofilo: 3, Residente: 2, potenza: 4.5, importo: 1050.51 }
  
          ]
        }
        ,schedaconfrontabilitagas:
        {
          tabellaConfrontabilita:[]
        }
        ,lstModalitaPagamento :["2"]
        ,scontoRid:0 
        ,TipoSoglieEle: Soglie.SogliaMomoEleNew()
        ,ImportoAnnuoLordo: 0
        ,ImportoAnnuoNetto: 0
        ,ImportoMensileLordo: 0
        ,ImportoMensileNetto: 0
        ,iscopertura: "" 
      };
    }
}



// WEBPACK FOOTER //
// ./src/app/archivioofferte/irenweb.ts